module.exports = __webpack_public_path__ + "static/media/datazip-icon.f646493f.svg";